import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobephonegapComponent } from './simple-icons-adobephonegap.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobephonegapComponent ],
    exports:      [ SimpleIconsAdobephonegapComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobephonegapModule {}
